var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 922,
    height: 615,
    viewBox: "0 0 922 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 415.203L99.3643 467.129C178.719 547.672 308.081 549.454 389.68 471.189L574.367 297.758L576.116 296.008C584.93 287.162 594.899 285.313 601.699 285.313C608.499 285.313 618.5 287.162 627.314 296.041L807.826 477.391",
    stroke: "#01C8A4",
    strokeWidth: 80.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M881.39 243.554L778.203 139.904C677.558 38.9619 514.36 38.9619 413.748 139.904L241.142 301.749L135.239 197.066",
    stroke: "#0178FF",
    strokeWidth: 80.18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.81 24.93C379.289 24.93 383.73 20.4887 383.73 15.01C383.73 9.53133 379.289 5.09 373.81 5.09C368.331 5.09 363.89 9.53133 363.89 15.01C363.89 20.4887 368.331 24.93 373.81 24.93Z",
    fill: "#01C8A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.28 15.77C358.17 15.77 349.98 23.96 349.98 34.07V108.2",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.17 272.68H572.89",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M660.25 191.88C650.14 191.88 641.95 200.07 641.95 210.18V362.85",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.96 67.17C295.08 67.17 298.42 63.83 298.42 59.71C298.42 55.59 295.08 52.25 290.96 52.25C286.84 52.25 283.5 55.59 283.5 59.71C283.5 63.83 286.84 67.17 290.96 67.17Z",
    fill: "#FF4868"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.1 78.01C268.1 67.9 276.29 59.71 286.4 59.71",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M732.16 144.76C734.739 144.76 736.83 142.669 736.83 140.09C736.83 137.511 734.739 135.42 732.16 135.42C729.581 135.42 727.49 137.511 727.49 140.09C727.49 142.669 729.581 144.76 732.16 144.76Z",
    fill: "#FF4868"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404.82 330.88C404.82 330.88 356.61 358.57 279.71 372.53C272.34 373.87 247.21 388.45 248.46 417.68C249.01 430.52 350.35 552.06 411.21 552.27C411.21 552.27 577.76 609.63 682.24 468.18C693.63 452.76 718.5 454.18 680.99 388.15C674.47 376.68 667.1 367.08 657.8 365.72C560.66 351.58 549.57 325.48 520.56 325.6C491.55 325.72 404.83 330.87 404.83 330.87L404.82 330.88Z",
    fill: "#1B1A45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M514.58 12.43C514.58 12.43 505.28 12.78 513.19 18.88C521.09 24.98 519.58 76.82 528.73 92.54C537.88 108.26 487.24 219.71 546.73 222.7C593.86 225.07 609.99 114.16 598.78 74.66C594.28 58.79 587.58 3.12999 514.58 12.43Z",
    fill: "#1B1A45"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.74 231.02C311.74 241.13 319.93 249.32 330.04 249.32C340.15 249.32 348.34 241.13 348.34 231.02C348.34 241.13 356.53 249.32 366.64 249.32C376.75 249.32 384.94 241.13 384.94 231.02C384.94 241.13 393.13 249.32 403.24 249.32C413.35 249.32 421.54 241.13 421.54 231.02C421.54 241.13 429.73 249.32 439.84 249.32C449.95 249.32 458.14 241.13 458.14 231.02C458.14 241.13 466.33 249.32 476.44 249.32C486.55 249.32 494.74 241.13 494.74 231.02C494.74 241.13 502.93 249.32 513.04 249.32C523.15 249.32 531.34 241.13 531.34 231.02C531.34 241.13 539.53 249.32 549.64 249.32C559.75 249.32 567.93 241.28 567.93 231.3C567.93 214.31 600.99 186.27 590.9 114.03C584.23 66.25 531.93 -26.72 431.54 36.12C331.09 98.99 279.04 210.12 275.4 214.75C275.28 214.9 275.19 215.05 275.12 215.23C274.92 215.72 275.12 232.36 275.12 231.04C275.12 241.15 283.31 249.34 293.42 249.34C303.53 249.34 311.72 241.15 311.72 231.04L311.74 231.02Z",
    fill: "#0E0836"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M420.04 177.47C420.04 177.47 421.2 269.87 421.37 284.85C421.54 299.83 424.53 312.59 404.81 330.88C404.81 330.88 504.2 480.94 504.2 529.02H561.51C561.51 529.02 568.85 331.05 520.54 325.6V240.79L420.03 177.46L420.04 177.47Z",
    fill: "#F6C9A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M576.36 172.75C576.36 182.86 584.55 191.05 594.66 191.05H606.66",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M520.55 268.11V245.34L509.31 233.72L420.04 166.7C420.04 166.7 420.23 192.4 420.46 211.22C429.03 241.07 464.47 286.5 491.65 286.5C506.82 286.5 515.6 277.15 520.54 268.1L520.55 268.11Z",
    fill: "#C5896F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M512.93 17.79C512.93 17.79 524.62 17.07 546.13 39.25C557.08 50.55 575.28 73 575.57 94.31C575.86 115.62 575.26 124.62 578.23 135.87C581.19 147.12 584.24 172.29 565.96 208.61C547.68 244.93 524 255.35 510.26 255.35C496.52 255.35 458.71 238.24 437.6 210.38C423.95 192.37 419.2 176.54 419.79 166.68C419.79 166.68 399.78 173.78 388.82 156.01C377.87 138.23 386.04 115.71 399.89 115.71C413.74 115.71 420.26 124.62 420.26 132.79C420.26 140.96 449.54 107.59 463.38 83.96C477.22 60.32 501.33 39.57 506.38 34.9C511.43 30.23 512.94 17.78 512.94 17.78L512.93 17.79Z",
    fill: "#F6C9A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M517.23 12.02C517.23 12.02 523.62 20.01 507.76 33.69C488.78 50.05 458.62 89.11 456.72 93.73C454.82 98.35 432.92 126.63 421.56 129.95C421.56 129.95 418.31 112.76 400.01 112.76C381.71 112.76 379.54 144.15 390.56 158.62C401.57 173.1 419.78 166.7 419.78 166.7C419.78 166.7 416.66 224.38 270.47 224.38C255.05 224.38 244.32 199.82 264.54 190.89C288.25 180.42 272.13 165.92 294.2 161.46C307.67 158.74 316.32 150.03 316.57 129.4C316.83 107.43 332.23 98.65 347.68 90.12C362.7 81.82 362.82 66.38 368.21 53.88C373.6 41.39 410.79 0 470.05 0C510.02 0 517.24 12.02 517.24 12.02H517.23Z",
    fill: "#1B1A45"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M522.65 195.56C524.75 195.36 528.45 193.46 529.01 193.1C529.57 192.74 530.88 191.89 532.77 193.96C534.66 196.03 544.81 194.65 545.49 195.71C546.17 196.77 543.1 204.38 538.51 204.02C533.92 203.66 535.08 203.64 535.08 203.64C535.08 203.64 533.27 214.06 521.67 214.06C510.07 214.06 506.69 211.78 506.69 206.36C506.69 206.36 495.02 204.45 487.37 196.4C486.87 195.87 487.33 195.01 488.05 195.12C493.12 195.96 505.8 197.64 509.65 194.31C514.51 190.11 515.78 192.62 516.58 193.27C517.38 193.92 519.6 195.85 522.65 195.55V195.56Z",
    fill: "#FF4868"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M506.01 99.65H452.69L456.25 94.67H506.01V99.65Z",
    fill: "#A20125"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M576.27 94.5H536.83V99.65H576.27V94.5Z",
    fill: "#A20125"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M505.3 172.7C506.6 172.05 508.14 168.35 512.23 168.35C516.32 168.35 518.54 172.7 519.47 172.7C520.4 172.7 521.73 169.99 517.78 166.71C513.83 163.43 508.28 165.02 505.7 168.09C503.12 171.16 504.5 173.11 505.3 172.71V172.7Z",
    fill: "#980210"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M534.12 165.32C535.41 163.94 539.76 161.5 539.76 161.5C539.76 161.5 538.52 164.65 536.3 166.96C534.08 169.27 532.48 170.78 531.64 170.2C530.8 169.62 534.13 165.32 534.13 165.32H534.12Z",
    fill: "#980210"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M493.39 150.93C495.97 145.72 495.83 127.32 490.81 130.25C470.19 142.28 455.02 137.2 449.78 139.42C444.54 141.64 434.88 161.37 448.64 169.89C460.37 177.16 483.64 170.63 493.39 150.92V150.93Z",
    fill: "#F7A3A6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M403.44 141.48C405.2 145.19 406.28 145.39 408.95 144.77C411.62 144.15 409.57 140.68 407.35 139.44C405.13 138.2 401.84 138.11 403.44 141.48Z",
    fill: "#F7A3A6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M539.55 132.17C536.07 130.12 536.55 142.5 539.76 149.05C554.5 179.07 578.63 172.94 579.19 169.5C580.35 162.36 580.41 156.1 580.38 150.78C580.37 148.43 579.95 143.67 578.88 138.65C578.88 138.65 563.16 146.08 539.55 132.17Z",
    fill: "#F7A3A6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M462 124.94C462 124.94 477.59 114.55 491.89 129.38C491.89 129.38 482.3 122.81 469.15 125.29C456.01 127.78 462 124.93 462 124.93V124.94Z",
    fill: "#1B1A45"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M604.39 83.59C606.582 83.59 608.36 81.8126 608.36 79.62C608.36 77.4274 606.582 75.65 604.39 75.65C602.197 75.65 600.42 77.4274 600.42 79.62C600.42 81.8126 602.197 83.59 604.39 83.59Z",
    fill: "#FF4868"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M736.04 186.19C739.972 186.19 743.16 183.002 743.16 179.07C743.16 175.138 739.972 171.95 736.04 171.95C732.108 171.95 728.92 175.138 728.92 179.07C728.92 183.002 732.108 186.19 736.04 186.19Z",
    fill: "#0178FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M692.25 255.23C695.011 255.23 697.25 252.991 697.25 250.23C697.25 247.469 695.011 245.23 692.25 245.23C689.489 245.23 687.25 247.469 687.25 250.23C687.25 252.991 689.489 255.23 692.25 255.23Z",
    fill: "#FF4868"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M785.7 260C788.649 260 791.04 257.609 791.04 254.66C791.04 251.711 788.649 249.32 785.7 249.32C782.751 249.32 780.36 251.711 780.36 254.66C780.36 257.609 782.751 260 785.7 260Z",
    fill: "#FF4868"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M660.25 335.17C663.199 335.17 665.59 332.779 665.59 329.83C665.59 326.881 663.199 324.49 660.25 324.49C657.301 324.49 654.91 326.881 654.91 329.83C654.91 332.779 657.301 335.17 660.25 335.17Z",
    fill: "#FF4868"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M633.1 289.17C636.226 289.17 638.76 286.636 638.76 283.51C638.76 280.384 636.226 277.85 633.1 277.85C629.974 277.85 627.44 280.384 627.44 283.51C627.44 286.636 629.974 289.17 633.1 289.17Z",
    fill: "#01C8A4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M559.63 311.83C562.944 311.83 565.63 309.144 565.63 305.83C565.63 302.516 562.944 299.83 559.63 299.83C556.316 299.83 553.63 302.516 553.63 305.83C553.63 309.144 556.316 311.83 559.63 311.83Z",
    fill: "#0178FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M300.11 313.3C303.578 313.3 306.39 310.488 306.39 307.02C306.39 303.552 303.578 300.74 300.11 300.74C296.642 300.74 293.83 303.552 293.83 307.02C293.83 310.488 296.642 313.3 300.11 313.3Z",
    fill: "#0178FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M411.21 450.89C414.739 450.89 417.6 448.029 417.6 444.5C417.6 440.971 414.739 438.11 411.21 438.11C407.681 438.11 404.82 440.971 404.82 444.5C404.82 448.029 407.681 450.89 411.21 450.89Z",
    fill: "#01C8A4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 300.75C369.912 300.75 373.1 297.562 373.1 293.63C373.1 289.698 369.912 286.51 365.98 286.51C362.048 286.51 358.86 289.698 358.86 293.63C358.86 297.562 362.048 300.75 365.98 300.75Z",
    fill: "#01C8A4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M349.43 259.44C352.738 259.44 355.42 256.758 355.42 253.45C355.42 250.142 352.738 247.46 349.43 247.46C346.122 247.46 343.44 250.142 343.44 253.45C343.44 256.758 346.122 259.44 349.43 259.44Z",
    fill: "#FF4868"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 238.93C176.062 238.93 178.82 236.172 178.82 232.77C178.82 229.368 176.062 226.61 172.66 226.61C169.258 226.61 166.5 229.368 166.5 232.77C166.5 236.172 169.258 238.93 172.66 238.93Z",
    fill: "#0178FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M651.73 536.34C657.126 536.34 661.5 531.966 661.5 526.57C661.5 521.174 657.126 516.8 651.73 516.8C646.334 516.8 641.96 521.174 641.96 526.57C641.96 531.966 646.334 536.34 651.73 536.34Z",
    fill: "#FF4868"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M590.4 257.58C593.095 257.58 595.28 255.395 595.28 252.7C595.28 250.005 593.095 247.82 590.4 247.82C587.705 247.82 585.52 250.005 585.52 252.7C585.52 255.395 587.705 257.58 590.4 257.58Z",
    fill: "#FF4868"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M290.96 182.55C296.356 182.55 300.73 178.176 300.73 172.78C300.73 167.384 296.356 163.01 290.96 163.01C285.564 163.01 281.19 167.384 281.19 172.78C281.19 178.176 285.564 182.55 290.96 182.55Z",
    fill: "#FF4868"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M625.23 25.61C628.638 25.61 631.4 22.8476 631.4 19.44C631.4 16.0324 628.638 13.27 625.23 13.27C621.822 13.27 619.06 16.0324 619.06 19.44C619.06 22.8476 621.822 25.61 625.23 25.61Z",
    fill: "#FF4868"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M377.96 480.01C382.743 480.01 386.62 476.133 386.62 471.35C386.62 466.567 382.743 462.69 377.96 462.69C373.177 462.69 369.3 466.567 369.3 471.35C369.3 476.133 373.177 480.01 377.96 480.01Z",
    fill: "#FF4868"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M543 124.94C543 124.94 558.59 114.55 572.89 129.38C572.89 129.38 563.3 122.81 550.15 125.29C537 127.77 543 124.93 543 124.93V124.94Z",
    fill: "#1B1A45"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M630.11 283.8C620 283.8 611.81 291.99 611.81 302.1V356.83",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M630.11 283.35C620 283.35 611.81 275.16 611.81 265.05V196.48",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M712.5 231.93C712.5 242.04 704.31 250.23 694.2 250.23",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M730.8 180.41C720.69 180.41 712.5 188.6 712.5 198.71V231.92",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M286.43 172.16C276.32 172.16 269 163.93 268.13 153.86C268.02 152.59 268.13 99.65 268.13 99.65",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M561.92 307.31C572.03 307.31 580.22 315.5 580.22 325.61V347.21",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M412.11 592.87C417.147 592.87 421.23 588.787 421.23 583.75C421.23 578.713 417.147 574.63 412.11 574.63C407.073 574.63 402.99 578.713 402.99 583.75C402.99 588.787 407.073 592.87 412.11 592.87Z",
    fill: "#0178FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M406.7 582.28C396.59 582.28 388.4 574.09 388.4 563.98V542.38",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M653 154.84C656.364 154.84 659.09 152.113 659.09 148.75C659.09 145.387 656.364 142.66 653 142.66C649.637 142.66 646.91 145.387 646.91 148.75C646.91 152.113 649.637 154.84 653 154.84Z",
    fill: "#0178FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M655.39 150.23C665.5 150.23 673.69 158.42 673.69 168.53V190.13",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M211.98 168.14C215.73 168.14 218.77 165.1 218.77 161.35C218.77 157.6 215.73 154.56 211.98 154.56C208.23 154.56 205.19 157.6 205.19 161.35C205.19 165.1 208.23 168.14 211.98 168.14Z",
    fill: "#0178FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M215.06 162.82C225.17 162.82 233.36 171.01 233.36 181.12V202.72",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M611.81 356.83C621.92 356.83 630.11 365.02 630.11 375.13V519.05",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M660.25 191.88L791.67 191.7C801.78 191.7 809.97 183.51 809.97 173.4V75.46",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M641.95 362.86C652.06 362.86 660.25 371.05 660.25 381.16V494.11",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M396.26 335.09C386.15 335.09 377.96 343.28 377.96 353.39V466.34",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M414.86 444.69C424.97 444.69 433.16 452.88 433.16 462.99V555.77",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M281.81 499.2V386.25C281.81 376.14 290 367.95 300.11 367.95V309.21",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M670.82 94.65C645.01 67.92 614.85 47.35 582 33.62C585.65 38.41 588.51 43.55 590.89 48.59C678.98 91.13 740.18 183.61 740.18 290.63C740.18 437.85 624.4 557.62 482.09 557.62C339.78 557.62 224 437.85 224 290.64C224 184.82 283.83 93.19 370.33 50.02C373.38 45.24 378.89 38.64 386.65 31.81C352.07 45.51 320.35 66.71 293.37 94.65C242.85 146.98 215.03 216.58 215.03 290.64C215.03 364.7 242.85 434.3 293.37 486.63C343.8 538.86 410.82 567.63 482.09 567.63C553.36 567.63 620.39 538.86 670.82 486.63C721.34 434.3 749.16 364.7 749.16 290.64C749.16 216.58 721.34 146.98 670.82 94.65Z",
    fill: "#FFB729"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M680.62 473.94H659.07C661.42 469.67 661.42 465.3 659.07 461.03H680.62C678.27 465.3 678.27 469.67 680.62 473.94Z",
    fill: "#FF9D9A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M724.34 504.84C718.14 485.23 696.25 470.74 670.21 470.74C644.17 470.74 622.28 485.23 616.08 504.84H724.34Z",
    fill: "#01C8A4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M724.33 504.84H616.07V512.18H724.33V504.84Z",
    fill: "#0178FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M669.49 463.34C683.717 463.34 695.25 451.807 695.25 437.58C695.25 423.353 683.717 411.82 669.49 411.82C655.263 411.82 643.73 423.353 643.73 437.58C643.73 451.807 655.263 463.34 669.49 463.34Z",
    fill: "#FF9D9A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M669.49 411.83C655.92 411.83 644.81 422.33 643.81 435.64C653.23 429.51 674.15 420.31 695.04 440.74C695.17 439.7 695.24 438.65 695.24 437.58C695.24 423.36 683.71 411.82 669.48 411.82L669.49 411.83Z",
    fill: "#F9CCAD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M598.52 440.74C603.524 440.74 607.58 436.684 607.58 431.68C607.58 426.676 603.524 422.62 598.52 422.62C593.516 422.62 589.46 426.676 589.46 431.68C589.46 436.684 593.516 440.74 598.52 440.74Z",
    fill: "#FF4868"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M580.22 347.21C590.33 347.21 598.52 355.4 598.52 365.51V424.83",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 298.03C365.98 298.03 366.26 348.36 365.98 348.08",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M611.81 201.29C617.465 201.29 622.05 196.705 622.05 191.05C622.05 185.395 617.465 180.81 611.81 180.81C606.154 180.81 601.57 185.395 601.57 191.05C601.57 196.705 606.154 201.29 611.81 201.29Z",
    fill: "#FF4868"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M255.26 242.05C260.054 242.05 263.94 238.164 263.94 233.37C263.94 228.576 260.054 224.69 255.26 224.69C250.466 224.69 246.58 228.576 246.58 233.37C246.58 238.164 250.466 242.05 255.26 242.05Z",
    fill: "#FF4868"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M349.43 251.67C349.43 241.56 341.24 233.37 331.13 233.37H259.77",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M264.1 73.62H242.55C244.9 69.35 244.9 64.98 242.55 60.71H264.1C261.75 64.98 261.75 69.35 264.1 73.62Z",
    fill: "#FF9D9A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M307.81 104.53C301.61 84.92 279.72 70.43 253.68 70.43C227.64 70.43 205.75 84.92 199.55 104.53H307.81Z",
    fill: "#01C8A4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M199.55 104.53H307.81C307.81 108.58 304.52 111.87 300.47 111.87H206.89C202.84 111.87 199.55 108.58 199.55 104.53Z",
    fill: "#0178FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M252.97 63.03C267.197 63.03 278.73 51.4969 278.73 37.27C278.73 23.0432 267.197 11.51 252.97 11.51C238.743 11.51 227.21 23.0432 227.21 37.27C227.21 51.4969 238.743 63.03 252.97 63.03Z",
    fill: "#FF9D9A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M252.97 11.52C239.4 11.52 228.29 22.02 227.29 35.33C236.71 29.2 257.63 20 278.52 40.43C278.65 39.39 278.72 38.34 278.72 37.27C278.72 23.05 267.19 11.51 252.96 11.51L252.97 11.52Z",
    fill: "#F9CCAD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M779.69 24.35H654.3C648.352 24.35 643.53 29.1719 643.53 35.12V111.02C643.53 116.968 648.352 121.79 654.3 121.79H779.69C785.638 121.79 790.46 116.968 790.46 111.02V35.12C790.46 29.1719 785.638 24.35 779.69 24.35Z",
    fill: "#FEF9EF",
    stroke: "#FFB729",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M771.98 39.72H662.05C660.415 39.72 659.09 41.0452 659.09 42.68V76.66C659.09 78.2948 660.415 79.62 662.05 79.62H771.98C773.615 79.62 774.94 78.2948 774.94 76.66V42.68C774.94 41.0452 773.615 39.72 771.98 39.72Z",
    fill: "#FFB729"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M709.6 87.22H661.95C660.348 87.22 659.05 88.5184 659.05 90.12C659.05 91.7216 660.348 93.02 661.95 93.02H709.6C711.201 93.02 712.5 91.7216 712.5 90.12C712.5 88.5184 711.201 87.22 709.6 87.22Z",
    fill: "#0178FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M772.2 87.22H724.55C722.948 87.22 721.65 88.5184 721.65 90.12C721.65 91.7216 722.948 93.02 724.55 93.02H772.2C773.802 93.02 775.1 91.7216 775.1 90.12C775.1 88.5184 773.802 87.22 772.2 87.22Z",
    fill: "#0178FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M709.6 96.75H661.95C660.348 96.75 659.05 98.0484 659.05 99.65C659.05 101.252 660.348 102.55 661.95 102.55H709.6C711.201 102.55 712.5 101.252 712.5 99.65C712.5 98.0484 711.201 96.75 709.6 96.75Z",
    fill: "#0178FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M772.2 96.75H724.55C722.948 96.75 721.65 98.0484 721.65 99.65C721.65 101.252 722.948 102.55 724.55 102.55H772.2C773.802 102.55 775.1 101.252 775.1 99.65C775.1 98.0484 773.802 96.75 772.2 96.75Z",
    fill: "#0178FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M709.6 106.39H661.95C660.348 106.39 659.05 107.688 659.05 109.29C659.05 110.892 660.348 112.19 661.95 112.19H709.6C711.201 112.19 712.5 110.892 712.5 109.29C712.5 107.688 711.201 106.39 709.6 106.39Z",
    fill: "#0178FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M772.2 106.39H724.55C722.948 106.39 721.65 107.688 721.65 109.29C721.65 110.892 722.948 112.19 724.55 112.19H772.2C773.802 112.19 775.1 110.892 775.1 109.29C775.1 107.688 773.802 106.39 772.2 106.39Z",
    fill: "#0178FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M643.53 42.65C633.42 42.65 625.23 34.46 625.23 24.35",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M790.46 58.45C800.54 57.76 809.28 65.38 809.97 75.46",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M604.39 81.82C604.39 91.93 612.58 100.12 622.69 100.12H643.54",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M365.98 348.08C355.87 348.08 347.68 356.27 347.68 366.38V519.05",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M752.31 121.78C752.31 131.89 744.12 140.08 734.01 140.08",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M756.75 273.28H735.2C737.55 269.01 737.55 264.64 735.2 260.37H756.75C754.4 264.64 754.4 269.01 756.75 273.28Z",
    fill: "#FF9D9A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M800.46 304.18C794.26 284.57 772.37 270.08 746.33 270.08C720.29 270.08 698.4 284.57 692.2 304.18H800.46Z",
    fill: "#01C8A4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M692.2 304.18H800.46C800.46 308.23 797.17 311.52 793.12 311.52H699.54C695.49 311.52 692.2 308.23 692.2 304.18Z",
    fill: "#0178FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M745.62 262.68C759.847 262.68 771.38 251.147 771.38 236.92C771.38 222.693 759.847 211.16 745.62 211.16C731.394 211.16 719.86 222.693 719.86 236.92C719.86 251.147 731.394 262.68 745.62 262.68Z",
    fill: "#FF9D9A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M745.62 211.17C732.05 211.17 720.94 221.67 719.94 234.98C729.36 228.85 750.28 219.65 771.17 240.08C771.3 239.04 771.37 237.99 771.37 236.92C771.37 222.7 759.84 211.16 745.61 211.16L745.62 211.17Z",
    fill: "#F9CCAD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M433.16 538.39C443.27 538.39 451.46 546.58 451.46 556.69",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M353.17 272.68C343.06 272.68 334.87 280.87 334.87 290.98V358.63C324.76 358.63 316.57 366.82 316.57 376.93V489.88",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 290.57C198.55 290.57 190.36 298.76 190.36 308.87",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M641.95 307.31C652.06 307.31 660.25 315.5 660.25 325.61",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M676.13 508.51C676.13 518.62 667.94 526.81 657.83 526.81",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M590.4 254.38C590.4 264.49 582.21 272.68 572.1 272.68",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 253.41C180.25 253.41 172.06 245.22 172.06 235.11",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 253.41C200.47 253.41 208.66 261.6 208.66 271.71",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 338.54C211.902 338.54 214.53 335.912 214.53 332.67C214.53 329.428 211.902 326.8 208.66 326.8C205.418 326.8 202.79 329.428 202.79 332.67C202.79 335.912 205.418 338.54 208.66 338.54Z",
    fill: "#FF4868"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 319.17C193.602 319.17 196.23 316.542 196.23 313.3C196.23 310.058 193.602 307.43 190.36 307.43C187.118 307.43 184.49 310.058 184.49 313.3C184.49 316.542 187.118 319.17 190.36 319.17Z",
    fill: "#FF4868"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 329.83V271.71",
    stroke: "#FFB729",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M270.19 368.76H248.64C250.99 364.49 250.99 360.12 248.64 355.85H270.19C267.84 360.12 267.84 364.49 270.19 368.76Z",
    fill: "#FF9D9A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M313.9 399.67C307.7 380.06 285.81 365.57 259.77 365.57C233.73 365.57 211.84 380.06 205.64 399.67H313.9Z",
    fill: "#01C8A4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M205.64 399.67H313.9C313.9 403.72 310.61 407.01 306.56 407.01H212.98C208.93 407.01 205.64 403.72 205.64 399.67Z",
    fill: "#0178FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M259.06 358.17C273.287 358.17 284.82 346.637 284.82 332.41C284.82 318.183 273.287 306.65 259.06 306.65C244.833 306.65 233.3 318.183 233.3 332.41C233.3 346.637 244.833 358.17 259.06 358.17Z",
    fill: "#FF9D9A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M259.06 306.65C245.49 306.65 234.38 317.15 233.38 330.46C242.8 324.33 263.72 315.13 284.61 335.56C284.74 334.52 284.81 333.47 284.81 332.4C284.81 318.18 273.28 306.64 259.05 306.64L259.06 306.65Z",
    fill: "#F9CCAD"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M308.684 447.269L257.867 465.945C251.035 468.456 247.532 476.031 250.043 482.863L294.206 603.024C296.717 609.856 304.291 613.36 311.124 610.848L361.94 592.172C368.772 589.661 372.275 582.086 369.764 575.254L325.601 455.093C323.09 448.261 315.516 444.757 308.684 447.269Z",
    fill: "#0178FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M317.663 460.951L259.901 482.181C259.108 482.472 258.701 483.351 258.993 484.144L297.622 589.25C297.914 590.044 298.793 590.45 299.586 590.159L357.349 568.929C358.142 568.638 358.548 567.758 358.257 566.965L319.627 461.859C319.336 461.066 318.456 460.66 317.663 460.951Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M332.67 597.94C336.597 597.94 339.78 594.757 339.78 590.83C339.78 586.903 336.597 583.72 332.67 583.72C328.743 583.72 325.56 586.903 325.56 590.83C325.56 594.757 328.743 597.94 332.67 597.94Z",
    fill: "#0E0836"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M295.334 456.234L273.858 464.127C273.065 464.418 272.659 465.297 272.95 466.091L273.254 466.917C273.545 467.71 274.425 468.116 275.218 467.825L296.693 459.932C297.486 459.64 297.893 458.761 297.601 457.968L297.298 457.142C297.006 456.349 296.127 455.942 295.334 456.234Z",
    fill: "#0E0836"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M478.09 128.93C476.08 128.93 474.44 127.3 474.44 125.28C474.44 124.52 474.67 123.81 475.07 123.23C474.94 123.23 474.81 123.21 474.68 123.21C471.65 123.21 469.19 125.67 469.19 128.7C469.19 131.73 471.65 134.19 474.68 134.19C477.71 134.19 480.17 131.73 480.17 128.7C480.17 128.56 480.16 128.42 480.15 128.29C479.56 128.69 478.85 128.93 478.09 128.93Z",
    fill: "#1B1A45"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M559.96 128.93C557.95 128.93 556.31 127.3 556.31 125.28C556.31 124.52 556.54 123.81 556.94 123.23C556.81 123.23 556.68 123.21 556.55 123.21C553.52 123.21 551.06 125.67 551.06 128.7C551.06 131.73 553.52 134.19 556.55 134.19C559.58 134.19 562.04 131.73 562.04 128.7C562.04 128.56 562.03 128.42 562.02 128.29C561.43 128.69 560.72 128.93 559.96 128.93Z",
    fill: "#1B1A45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.e3bf6facde09f1aab3038aafa1ad4acd.svg";
export { ForwardRef as ReactComponent };